import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Admin from "./pages/Admin";
import OpsPortal from "./pages/OpsPortal";
import InvitationsPage from "./pages/InvitationsPage";
import AIInvitationsPage from "./pages/AIInvitationsPage";
import { PrivacyPolicy, TermsOfService } from "./pages/Legal";
import VendorRegistration from "./pages/VendorRegistration";
import DecoratorRegistration from "./pages/DecoratorRegistration";
import CancelBookingPage from "./pages/CancelBookingPage";
import CustomerPortal from "./pages/CustomerPortal";
import TrackBooking from "./pages/TrackBooking";
import CompleteBooking from "./pages/CompleteBooking";
import Gallery from "./pages/Gallery";
import DoozyGoMagic from "./pages/DoozyGoMagic";
import RSVPPage from "./pages/RSVPPage";
import DecoratorTracker from "./pages/DecoratorTracker";
import VendorMarketplace from "./pages/VendorMarketplace";
import VendorPortal from "./pages/VendorPortal";
import CreatorsPage from "./pages/CreatorsPage";
import PlanWithFriends from "./pages/PlanWithFriends";
import { SplitPaySetup, PoolTracker, FriendPayPage } from "./pages/SplitPay";
import Leaderboard from "./pages/Leaderboard";
import CreatorLeaderboard from "./pages/CreatorLeaderboard";
import CreatorDashboard from "./pages/CreatorDashboard";
import CreatorReferralCatcher from "./pages/CreatorReferralCatcher";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import DoozyBotWidget from "./components/DoozyBotWidget";
import DPDPBanner from "./components/DPDPBanner";
import SplashGate from "./components/SplashGate";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <CustomerAuthProvider>
      <SplashGate>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/invitations" element={<AIInvitationsPage />} />
        <Route path="/invitations/templates" element={<InvitationsPage />} />
        <Route path="/ai-invitations" element={<AIInvitationsPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/ops" element={<OpsPortal />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/vendor-register" element={<VendorRegistration />} />
        <Route path="/vendor-register/:magicToken" element={<VendorRegistration />} />
        <Route path="/decorator-registration" element={<DecoratorRegistration />} />
        <Route path="/cancel-booking" element={<CancelBookingPage />} />
        <Route path="/my-account" element={<CustomerPortal />} />
        <Route path="/track/:bookingId" element={<TrackBooking />} />
        <Route path="/booking/:token" element={<CompleteBooking />} />
        {/* Gallery hidden — re-enable when ready: <Route path="/gallery" element={<Gallery />} /> */}
        <Route path="/doozygo-magic" element={<DoozyGoMagic />} />
        <Route path="/magic/:jobId" element={<DoozyGoMagic />} />
        <Route path="/rsvp/:inviteId" element={<RSVPPage />} />
        <Route path="/field-tracker" element={<DecoratorTracker />} />
        <Route path="/vendors" element={<VendorMarketplace />} />
        <Route path="/vendor-portal" element={<VendorPortal />} />
        <Route path="/creators" element={<CreatorsPage />} />
        <Route path="/plan-with-friends" element={<PlanWithFriends />} />
        <Route path="/split-pay" element={<SplitPaySetup />} />
        <Route path="/pool/:poolId" element={<PoolTracker />} />
        <Route path="/pool/:poolId/pay/:friendId" element={<FriendPayPage />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/creators/leaderboard" element={<CreatorLeaderboard />} />
        <Route path="/creators/dashboard" element={<CreatorDashboard />} />
        <Route path="/r/:code" element={<CreatorReferralCatcher />} />
      </Routes>
      </SplashGate>
      <PWAInstallPrompt />
      {/* Global toast host — used by DoozyAd async Sora 2 job notifications + other async flows */}
      <Toaster position="top-right" richColors closeButton offset={72} />
      {/* Public "Doozy" mascot (sales/FAQ bot) — hidden on internal staff routes.
          Internal staff see the "DoozyBot" (ops manager + coach + suggestions) instead. */}
      <PublicDoozyGate />
      <DPDPGate />
      </CustomerAuthProvider>
    </BrowserRouter>
  );
}

// DPDP banner shown on public surfaces only (internal admin/ops use their own consent flow)
const DPDPGate = () => {
  const { pathname } = useLocation();
  const internalRoutes = ["/admin", "/ops", "/vendor-portal", "/field-tracker"];
  if (internalRoutes.some((p) => pathname.startsWith(p))) return null;
  return <DPDPBanner />;
};

// Hide the public-facing Doozy bot on internal dashboards
const PublicDoozyGate = () => {
  const { pathname } = useLocation();
  const internalRoutes = ["/admin", "/ops", "/vendor-portal", "/my-account", "/field-tracker"];
  if (internalRoutes.some((p) => pathname.startsWith(p))) return null;
  return <DoozyBotWidget />;
};

export default App;
